// Imports
import React from 'react';
import DateTimeCell from '../../../shareables/foundation/front-end/components/tables/date-time-cell';
import { GetActivitiesResponse } from '../../../shareables/types/api/main/reseller/activities/get';


// Define the accepted props
interface Props {
	activity: GetActivitiesResponse[0];
}


// Function component
const ActivityLogRow: React.FC<Props> = ({ activity: { occurred, action, details, user } }) => (
	<tr>
		<DateTimeCell dateTime={occurred} breakBetween />
		
		<td className='allow-wrapping'>
			{action}
			<small className='is-gray'>{details}</small>
		</td>
		
		<td>
			{user ? (
				`${user.firstName} ${user.lastName}`
			) : (
				<small>
					<em>None</em>
				</small>
			)}
		</td>
	</tr>
);

export default ActivityLogRow;
